import React from "react";
import { Construction } from "lucide-react";
import Layout from "../components/Layout";
import GlassCard from "../components/GlassCard";
import SectionHeader from "../components/SectionHeader";

export const Placeholder = ({ label, title, highlight, body, testid }) => (
  <Layout>
    <section className="py-24 md:py-32 px-6" data-testid={testid}>
      <div className="max-w-3xl mx-auto text-center">
        <SectionHeader label={label} title={title} highlight={highlight} />
        <GlassCard hover={false} className="p-12">
          <span className="inline-flex w-16 h-16 rounded-full items-center justify-center mb-5" style={{ background: "rgba(187,0,0,0.12)" }}>
            <Construction size={30} color="#BB0000" />
          </span>
          <p className="text-[#E0E0E0] leading-relaxed">{body}</p>
        </GlassCard>
      </div>
    </section>
  </Layout>
);

export const Productions = () => (
  <Placeholder
    testid="productions-page"
    label="Productions"
    title="Our" highlight="Litters & Lines"
    body="This page will soon showcase our past and upcoming litters, breeding productions, and the bloodlines behind Kallie's Kennel. Check back soon for photos and details of our newest Frenchies."
  />
);

export const OwnerUpdates = () => (
  <Placeholder
    testid="owner-updates-page"
    label="Owner Updates"
    title="Happy" highlight="Frenchie Families"
    body="A growing gallery of testimonials and update photos from our puppy families. As our Frenchies settle into their forever homes, their stories and smiles will live here."
  />
);

export default Productions;
